export default __webpack_public_path__ + "media/images/features/hida/ogp-9300c556b781b217b9da4259dcb60d09.jpg";